import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vzrf/react-theme-helpers';

const propTypes = {
  direction: PropTypes.string.isRequired,
  handleScroll: PropTypes.func.isRequired,
  scrollStyles: PropTypes.object,
  show: PropTypes.bool,
};

const defaultProps = {
  scrollStyles: {},
  show: false,
};

const buildAfterStyles = props => {
  const { theme, direction, scrollStyles } = props;
  let content =
    direction === 'left' ? '\\e993' : '\\e9f3'; /* <> Caret Symbols */
  if (typeof scrollStyles.content !== 'undefined') {
    content = scrollStyles.content;
  }

  // Get Font Family from Theme or scrollStyles overrides
  let css = '';
  css += `font-family: ${
    typeof scrollStyles.fontFamily !== 'undefined'
      ? scrollStyles.fontFamily
      : theme.iconFont
  };\n`;
  css += `content: '${content}';\n`; /* Direction Arrow Symbol */

  return css;
};

const ChipScrollButtonStyled = styled.button.attrs(props => ({
  title: props.direction === 'left' ? 'Scroll Left' : 'Scroll Right',
}))`
  display: none;
  //display: inline-block;
  cursor: pointer;
  ::after {
    ${props => buildAfterStyles(props)}
  }
  @media screen and (min-width: ${breakpoints.xs}) {
    //display: inline-block;
    display: none;
    flex: 1;
    width: ${calculateRem(35)};
    min-width: ${calculateRem(35)};
    max-width: ${calculateRem(35)};
    height: 100%;
    margin: 0px 3px;
    margin: 0;
    background: none;
    border: none;
    border-left: ${({ direction, theme }) =>
      direction === 'right'
        ? `${calculateRem(1)} solid ${theme.coolGray3}`
        : ''};
    border-right: ${({ direction, theme }) =>
      direction === 'left'
        ? `${calculateRem(1)} solid ${theme.coolGray3}`
        : ''};
  }
`;

const FilterChipScrollButton = props => {
  if (!props.show) {
    return null;
  }

  return (
    <ChipScrollButtonStyled
      direction={props.direction}
      onClick={e => props.handleScroll(props.direction, e)}
      scrollStyles={props.scrollStyles}
      style={{ ...props.scrollStyles, content: undefined }}
    />
  );
};

FilterChipScrollButton.propTypes = propTypes;
FilterChipScrollButton.defaultProps = defaultProps;

export default FilterChipScrollButton;
